var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"color":"deep-purple","dark":"","depressed":"","height":"40"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-database-import")]),_vm._v(" "+_vm._s(_vm.$t("initial_state"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }